import * as THREE from 'three';
import { AFrameCamera } from '../types';

export const imageCoordToSpherePos = (
  x: number,
  y: number,
  imageWidth: number,
  imageHeight: number,
  radius: number = 1
): THREE.Vector3 => {
  const u = x / imageWidth;
  const v = y / imageHeight;

  const lon = (u * 360 - 180) * (Math.PI / 180);
  const lat = (90 - v * 180) * (Math.PI / 180);

  const x3 = radius * Math.cos(lat) * Math.sin(lon);
  const y3 = radius * Math.sin(lat);
  const z3 = -radius * Math.cos(lat) * Math.cos(lon);

  return new THREE.Vector3(x3, y3, z3);
};

export function rotateY(
  coords: [number, number, number],
  degrees: number
): [number, number, number] {
  const [x, y, z] = coords;
  const rad = (degrees * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  return [
    cos * x - sin * z,
    y,
    sin * x + cos * z,
  ];
}


export const freezeCamera = (freeze: boolean, camera: AFrameCamera) => {
  if (freeze) {
    camera.setAttribute('custom-look-controls', 'enabled', 'false');
  } else {
    camera.setAttribute('custom-look-controls', 'enabled', 'true');
  }
};
